export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type GCustomerLocationFilterOptions = {
  __typename?: 'CustomerLocationFilterOptions';
  cities: Array<Scalars['String']>;
  states: Array<Scalars['String']>;
  zips: Array<Scalars['String']>;
};

export enum GCustomerLocationMetrobiEligibilityFilter {
  Eligible = 'ELIGIBLE',
  Excluded = 'EXCLUDED'
}

export enum GCustomerLocationRoutingFilter {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type GCustomerLocationsInput = {
  city?: InputMaybe<Scalars['String']>;
  cohortId?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<Scalars['ID']>>;
  metrobiEligibility?: InputMaybe<GCustomerLocationMetrobiEligibilityFilter>;
  notInCohortIds?: InputMaybe<Array<Scalars['ID']>>;
  routing?: InputMaybe<GCustomerLocationRoutingFilter>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  warehouseId?: InputMaybe<Scalars['ID']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type GQuery = {
  __typename?: 'Query';
  customerLocationFilterOptions: GCustomerLocationFilterOptions;
};


export type GQueryCustomerLocationFilterOptionsArgs = {
  warehouseId: Scalars['ID'];
};

export type GRouteManagementGetCustomerLocationFilterOptionsQueryVariables = Exact<{
  warehouseId: Scalars['ID'];
}>;


export type GRouteManagementGetCustomerLocationFilterOptionsQuery = { __typename?: 'Query', customerLocationFilterOptions: { __typename?: 'CustomerLocationFilterOptions', states: Array<string>, cities: Array<string>, zips: Array<string> } };
